import { isValidCPF } from "utils/cpf";

export interface ParseCpfListResult {
  cpfs: string[];
  error: string | null;
}

const MIN_CPFS = 1;
const MAX_CPFS = 10;
const CPF_DIGIT_COUNT = 11;

export function parseCpfList(input: string): ParseCpfListResult {
  const segments = input
    .split(",")
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0);

  if (segments.length < MIN_CPFS) {
    return { cpfs: [], error: "Informe ao menos um CPF" };
  }

  if (segments.length > MAX_CPFS) {
    return { cpfs: [], error: `Máximo de ${MAX_CPFS} CPFs por consulta` };
  }

  const cpfs: string[] = [];
  for (const segment of segments) {
    const digits = segment.replace(/\D/g, "");
    if (digits.length !== CPF_DIGIT_COUNT || !isValidCPF(digits)) {
      return { cpfs: [], error: `CPF inválido: "${segment}"` };
    }
    cpfs.push(digits);
  }

  return { cpfs, error: null };
}
